module.exports = __webpack_public_path__ + "img/zwtp.e5592e13.jpg";